import React, { useEffect, useState, useRef } from 'react'
import LinearProgress from '@mui/material/LinearProgress'
import { Stack, Typography } from '@mui/material'

const MimicProgressBar = () => {
  const [progress, setProgress] = useState(0)
  const intervalRef = useRef(null)

  useEffect(() => {
    const duration = 120000 // 2 minutes in milliseconds
    const steps = 100
    const increment = 100 / steps
    const intervalTime = duration / steps

    intervalRef.current = setInterval(() => {
      setProgress((prev) => {
        if (prev + increment >= 100) {
          clearInterval(intervalRef.current)
          return 100
        }
        return prev + increment
      })
    }, intervalTime)

    // Cleanup interval on unmount
    return () => clearInterval(intervalRef.current)
  }, [])

  // Simulate API call (e.g. resolve in 20 seconds)
  useEffect(() => {
    const apiTimeout = setTimeout(() => {
      setProgress(100)
      clearInterval(intervalRef.current)
    }, 120000) // 120 seconds

    return () => clearTimeout(apiTimeout)
  }, [])

  return (
    <LinearProgress
      variant="determinate"
      value={progress}
      color="success"
      sx={{
        height: 10,
        borderRadius: 2,
        width: '100%',
      }}
    />
  )
}

export default MimicProgressBar
